import { formatDate, formatBoolean, formatUrl, normalizeValue } from '../../utils/formatUtils';

/**
 * Reusable field renderer component for displaying key-value pairs
 * Used in StudentList and other components that display structured data
 */
const FieldRenderer = ({ label, value, type = "text" }) => {
  // Normalize the value first
  let normalizedValue = normalizeValue(value);
  
  // Format based on type
  if (type === "date") {
    normalizedValue = formatDate(normalizedValue);
  } else if (type === "boolean") {
    normalizedValue = formatBoolean(normalizedValue);
  } else if (type === "url" && normalizedValue) {
    normalizedValue = formatUrl(normalizedValue);
  }
  
  return (
    <div className="flex flex-col sm:flex-row sm:items-center">
      <span className="font-semibold text-gray-700 min-w-[140px] text-sm">{label}:</span>
      <span className="text-gray-900 text-sm">
        {type === "url" && normalizedValue !== "—" && normalizedValue !== null ? (
          <a 
            href={normalizedValue} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-blue-600 hover:underline"
          >
            {normalizedValue}
          </a>
        ) : (
          normalizedValue || "—"
        )}
      </span>
    </div>
  );
};

export default FieldRenderer;



